export class LoanCollateralModel {
    
        constructor(
            collateralId :number,
            collateralTypeId :number,
            collateralTypeName :string,
            collateralSubTypeId :number,
            customerId :number,
            collateralCode :string,
            allowSharing :boolean,
            isLocationBased :boolean,
            valuationCycle :number,
            haircut :number,
            collateralValue : number,
            hasInsurance :boolean,
           
        ) {
    
        }
    }
    